// Look for permissions. If it exists, enable it. If the permission has a '*' then enable
// it for everyone.
const permissionsMapping = {
  'Update primary agent': '[dashboard]/customers/actions/update_primary_agent', // Okay to use remove_agent permission for update.
  'Send message': '[dashboard]/customers/actions/send_message',
  'Request feedback': '[dashboard]/customers/actions/send_survey',
  'Update segments': '[dashboard]/customers/actions/update_segment',
  'Close conversation': '[dashboard]/customers/actions/close_conversation',
  'Update assigned agents': '[dashboard]/customers/actions/update_agents',
};

export const filterActionsByPermissions = (actions = {}, permissions = {}) => Object.keys(actions).filter(k => permissionsMapping[k] === '*' || permissions[permissionsMapping[k]]);

const usersPermissionsMapping = {
  'Mark away': '[dashboard]/users/actions/mark_away',
  'Update agent status': '[dashboard]/users/actions/mark_away',
  'Send notification': '[dashboard]/users/actions/send_notification',
};

export const filterUsersActionsByPermissions = (actions = {}, permissions = {}) => Object.keys(actions).filter(k => usersPermissionsMapping[k] === '*' || permissions[usersPermissionsMapping[k]]);
